import React from "react";
import { Link } from 'gatsby';
import { css } from '@emotion/core';

const Pagination = ({ type, urlKey, currentPage, totalPages }) => {
  return (
    <div css={css`
      display: flex;
      justify-content: center;
      margin-top: 2.5rem;

      a {
        padding: 0 1rem;

        &.current {
          border: none;
          opacity: 0.6;
          pointer-events: none;
        }
      }
    `}>
      {Array.from({ length: totalPages }).map((_, i) => {
        const pageNo = i + 1;
        const href = `/${type}/${urlKey}` + (pageNo === 1 ? '' : `/${pageNo}`);
        return <Link key={pageNo} className={pageNo === currentPage ? 'current' : ''} to={href}>{pageNo}</Link>;
      })}
    </div>
  );
};

export default Pagination;
